import styled from 'styled-components';
export var Label = styled.span.attrs(function (props) {
  return {
    $value: props.value,
    value: undefined
  };
}).withConfig({
  displayName: "Label",
  componentId: "sc-1esfagn-0"
})(["white-space:nowrap;", " ", " ", ""], function (_ref) {
  var bold = _ref.bold;
  return bold ? 'font-weight: 700;' : '';
}, function (_ref2) {
  var withPositive = _ref2.withPositive,
    $value = _ref2.$value,
    theme = _ref2.theme;
  return withPositive && $value > 0 ? "color: ".concat(theme.colors.positive) : '';
}, function (_ref3) {
  var withNegative = _ref3.withNegative,
    $value = _ref3.$value,
    theme = _ref3.theme;
  return withNegative && $value < 0 ? "color: ".concat(theme.colors.negative) : '';
});